// extracted by mini-css-extract-plugin
module.exports = {"container":"x_b","list":"x_w","short":"x_bq","element":"x_y","small":"x_br","shadow":"x_z","scroll":"x_bs","dark":"x_bt"};